/**
 * Seção "Limites éticos" em modo edição (Brief 4 · Tela 2 · PR4).
 *
 * Dois editores de chips (tópicos de redirecionamento / limites de tom) sobre o
 * draft. Editar qualquer lista substitui o objeto `ethicalBoundaries` inteiro
 * (R15: o backend grava o objeto completo). A leitura mostra `toneLimits` como
 * lista vertical; na edição ambos são chips (entradas curtas, mesmo editor) —
 * decisão de UX consistente com o ChipListEditor, sem fabricar campo.
 */

import { PersonaChipEditor } from './PersonaChipEditor';
import { ToneLimitsNote } from './ToneLimitsNote';

import type { PersonaForm } from '../use-persona-form';

export function SectionEthicsEdit({ form }: { form: PersonaForm }): JSX.Element {
  const { ethicalBoundaries } = form.draft;

  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Limites éticos</h2>
      <p className="pe-panel__subtitle">Tópicos que a IA redireciona e limites de tom.</p>
      <div className="pe-field">
        <span className="pe-field__label">Tópicos de redirecionamento</span>
        <PersonaChipEditor
          values={ethicalBoundaries.redirectTopics}
          ariaLabel="Adicionar tópico de redirecionamento"
          placeholder="ex.: cobrança → financeiro"
          onChange={(next) => {
            form.set('ethicalBoundaries', { ...ethicalBoundaries, redirectTopics: next });
          }}
        />
      </div>
      <div className="pe-field">
        <span className="pe-field__label">Limites de tom</span>
        <PersonaChipEditor
          values={ethicalBoundaries.toneLimits}
          ariaLabel="Adicionar limite de tom"
          placeholder="ex.: nunca prometer prazo"
          onChange={(next) => {
            form.set('ethicalBoundaries', { ...ethicalBoundaries, toneLimits: next });
          }}
        />
        <ToneLimitsNote />
      </div>
    </section>
  );
}
